import { Directive, model, numberAttribute, input } from '@angular/core';
import { LoggerService } from '../shared/logger.service';

/**
 * Source of example:
 * https://medium.com/@groupp/effective-debouncing-in-angular-keep-signals-pure-703eb105a495
 */

@Directive({
  selector: 'input[debounceTime]',
  standalone: true,
  host: {
    '[value]': 'value()',
    '(input)': `handleInput($event!.target)`
  }
})
export class DebounceTime {
  #debouceTimer?: ReturnType<typeof setTimeout>;

  readonly debounceTime = input(0, { transform: numberAttribute });
  readonly value = model<string>();
  constructor(
    private logger: LoggerService
  ) { }

  handleInput(target: EventTarget | null): void {
    clearTimeout(this.#debouceTimer);
    const _target = target as HTMLInputElement;
    const value = _target.value;
    this.logger.debug(`handleInput:debouceTime: `, this.debounceTime());
    if (!value || !this.debounceTime()) {
      this.value.set(value);
    } else {
      this.#debouceTimer = setTimeout(() => this.value.set(value),
        this.debounceTime());
    }
  }

}
